<template>
  <transition name="fade-slide">
    <button 
      v-if="visible" 
      class="back-to-top" 
      @click="scrollToTop"
      aria-label="回到顶部"
    >
<i class="el-icon-top"></i>
    </button>
  </transition>
</template>

<script>
export default {
  name: 'BackToTop',
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.visible = window.scrollY > 300
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  },
  components: {
    ArrowUpIcon: {
      template: `
        <svg width="20" height="20" viewBox="0 0 20 20">
          <path d="M10 4L10 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M4 10L10 4L16 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `
    }
  }
}
</script>

<style lang="scss" scoped>

.back-to-top {
  position: fixed;
  right: 40px;
  bottom: 20px;
  width: 48px;
  height: 48px;
  background: var(--primary);
  border: none;
  border-radius: 50%;
  color: var(--white);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(30, 90, 170, 0.3);
  transition: all 0.3s ease;
  z-index: 100;

  &:hover {
    background: var(--primary);
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(30, 90, 170, 0.4);
  }

  @media (max-width: 768px) {
    right: 20px;
    bottom: 20px;
    width: 40px;
    height: 40px;
  }
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>